import $ from 'jquery';
import type {
  AnalyticsOptions,
  SegmentTraits,
  UserActivityTrackerConfig,
} from './types/analytics';
import userActivityTracker from './user-activity-tracker';

export function segmentTrack(
  event: string,
  properties?: Record<string, any>
): void {
  if (
    typeof (window as any).analytics !== 'undefined' &&
    (window as any).analytics?.track
  ) {
    (window as any).analytics.track(event, properties);
  }
}

export function segmentIdentify(
  userId?: string,
  traits?: Record<string, any>
): void {
  if (
    typeof (window as any).analytics !== 'undefined' &&
    (window as any).analytics?.identify
  ) {
    if (userId) {
      (window as any).analytics.identify(userId, traits);
    } else {
      (window as any).analytics.identify(traits);
    }
  }
}

interface EventDimensions {
  orgname?: string;
  buyer?: string;
  seller?: string;
}

/**
 * Set event dimensions for Segment
 * @param analyticsOpts - Analytics options containing dimension data
 */
export function setEventDimensions(analyticsOpts: EventDimensions): void {
  // Send to Segment Analytics
  const traits: SegmentTraits = {};
  if (analyticsOpts.orgname) traits.orgname = analyticsOpts.orgname;
  if (analyticsOpts.buyer) traits.buyer = analyticsOpts.buyer;
  if (analyticsOpts.seller) traits.seller = analyticsOpts.seller;

  segmentIdentify(undefined, traits);
}

/**
 * Track an event in Segment
 * @param category - Event category
 * @param action - Event action
 * @param opt_label - Optional event label
 * @param opt_value - Optional event value
 * @param nonInteraction - Whether this is a non-interaction event
 */
export function trackEvent(
  category: string,
  action: string,
  opt_label?: string | null,
  opt_value?: number | null,
  nonInteraction: boolean = false
): void {
  const eventLabel = opt_label || null;
  const eventValue = opt_value || null;

  // Send to Segment Analytics
  const properties = {
    category: category,
    label: eventLabel,
    value: eventValue,
    nonInteraction: nonInteraction,
  };
  segmentTrack(action, properties);
}

/**
 * Track custom events in Segment
 * @param segmentEventName - Human-readable event name for Segment
 * @param properties - Event properties to send
 */
export function trackCustomEvent(
  segmentEventName: string,
  properties: Record<string, any> = {}
): void {
  // Send to Segment Analytics
  segmentTrack(segmentEventName, properties);
}

// Set up click handlers for download tracking
$(
  '.report-download, .download-coa-pdp, .download-product-instructions, .download-product-marketing-materials'
).on('click', function (this: HTMLElement) {
  const analyticsOpts = $(this).data('analytics-options') as
    | AnalyticsOptions
    | undefined;

  if (analyticsOpts) {
    setEventDimensions(analyticsOpts);
    trackEvent(
      analyticsOpts.category,
      analyticsOpts.action,
      analyticsOpts.label,
      analyticsOpts.value,
      true // nonInteraction = true for downloads
    );
  }
});

// Initialize user activity tracker
const activityConfig: UserActivityTrackerConfig = {
  verbose: false,
  heartbeatInterval: 15 * 60 * 1000, // 15 minutes
  idleTimeout: 30 * 60 * 1000, // 30 minutes
};

userActivityTracker.init(activityConfig);

$(document).ready(() => {
  if (
    typeof (window as any).analytics !== 'undefined' &&
    (window as any).analytics?.page
  ) {
    (window as any).analytics.page();
  }
});
